// extracted by mini-css-extract-plugin
export var activityLevelAlignFix = "PortExcursionModal-module--activity-level-align-fix--049cf";
export var body = "PortExcursionModal-module--body--06ba7";
export var content = "PortExcursionModal-module--content--2262c";
export var icons = "PortExcursionModal-module--icons--9ce06";
export var iconsRow = "PortExcursionModal-module--icons-row--b77aa";
export var image = "PortExcursionModal-module--image--8c9d2";